<template>
  <div class="cf-flex cf-flex--column cf-flex--gap-8">
    <p class="cf-subtitle cf-subtitle--2 cf-subtitle--heavy">
      {{ faqCategoryItem.question }}
    </p>

    <p class="cf-subtitle cf-subtitle--2">
      {{ faqCategoryItem.answer }}
    </p>
  </div>
</template>


<script>
  export default {
    name: 'CategoryQuestion',

    props: {
      faqCategoryItem: {
        type: Object,
        required: true
      }
    }
  };
</script>
